import { render, staticRenderFns } from "./StowageDetail.vue?vue&type=template&id=6f374e95&"
import script from "./StowageDetail.vue?vue&type=script&lang=js&"
export * from "./StowageDetail.vue?vue&type=script&lang=js&"
import style0 from "./StowageDetail.vue?vue&type=style&index=0&id=6f374e95&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports